import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-dotted-arrow-down",
  "use": "icon-s-dotted-arrow-down-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-dotted-arrow-down\"><path d=\"M9.596 9v8.03l-6.273-6.274L2 12.08l8.596 8.596 1.323-1.322 7.274-7.274-1.323-1.323-6.274 6.274V9zm.97 9h.06l-.03.03zm-.97-11h2V5h-2zm0-3.999h2V1h-2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol